import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import { RemoteGenerateOTP } from "../../../data/usecases/remote-generate-otp";
import Endpoints from "../../../domain/endpoints";
import { GenerateOTP } from "../../../domain/useages/generate-otp";
import Swal from "sweetalert2";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface GenerateOTPInterface {
  generateOtp: Function;
  OtpStatus: any;
}

const intitalState = {
  OtpStatus: {},
};
const axiosHttpClient = AxiosHttpClient.getInstance();


export const useGenerateOTPSlice: StateCreator<GenerateOTPInterface> = (
  set,
  get
) => ({
  ...intitalState,
  generateOtp: async (payload: GenerateOTP.Params) => {
 const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
 const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteUpdateFulfilmentAgent = new RemoteGenerateOTP(
      `${BASE_URL}${Endpoints.GENERATE_OTP}`,
      axiosHttpClient
    );

    let result = await remoteUpdateFulfilmentAgent.generate(payload);
    if (result) {
      set(() => ({ OtpStatus: result }));
      if (result.success) {
        Swal.fire({
          icon: "success",
          timer: 2000,
          text: result.message,
          customClass: {
            container: "swal2-style",
          },
        });
      }
    }
    if (!result.success) {
      if (result.errors) {
        let errorText = "";
        for (let x in result.errors) {
          errorText += result.errors[x] + "\n";
        }
        Swal.fire({
          timer: 2000,
          icon: "error",
          text: errorText.replace(/\w+/g, function (w) {
            return w[0].toUpperCase() + w.slice(1).toLowerCase();
          }),
          customClass: {
            container: "swal2-style",
          },
        });
      } else {
        Swal.fire({
          timer: 2000,
          icon: "error",
          text: result.message.replace(/\w+/g, function (w: any) {
            return w[0].toUpperCase() + w.slice(1).toLowerCase();
          }),
          customClass: {
            container: "swal2-style",
          },
        });
      }
    }
  },
});
